import { useIntl } from "react-intl";
import { serviceHolderUserStatusList } from "../../../../../../../api/serviceHolder/userStatus";
import useFormatters from "../../../../../../../components/FormattedFields/useFormatters";
import { areasList } from "../../../../../../../util/defaults/areas";
import { caretakerOptionsList } from "../../../../../../../util/defaults/caretakerAdoption";
import { emotionalStatusList } from "../../../../../../../util/defaults/emotionalCharacter";
import { familiarUnitsList } from "../../../../../../../util/defaults/familiarUnit";
import { mobilityOptionsList } from "../../../../../../../util/defaults/mobility";
import { regionsList } from "../../../../../../../util/defaults/provincias";
import { sleepQualityOptionList } from "../../../../../../../util/defaults/sleepQuality";
import { speechLevelsList } from "../../../../../../../util/defaults/speechLevel";
import { degreesListWithNotNeededOption } from "../../../../../../../util/defaults/titulaciones";
import { toiletLevelsList } from "../../../../../../../util/defaults/toiletLevel";
import { dependencyGradesList } from "../../../../../../../util/defaults/dependency";

export default function useServiceValuationFormOptions() {
  const { formatMessage } = useIntl();
  const {
    formatFamiliarUnit,
    formatServiceHolderEmotionalStatus,
    formatServiceHolderAdopt,
    formatSpeechLevel,
    formatMobilityOption,
    formatServiceHolderSleepQuality,
    formatServiceHolderToiletLevel,
    formatServiceHolderUserStatus,
  } = useFormatters();

  const regionOptions = regionsList().map((region) => ({
    value: region.value,
    label: region.value,
  }));
  const areaOptions = areasList().map((region) => ({
    value: region.value,
    label: region.value,
  }));
  const familiarUnitOptions = familiarUnitsList().map((unit) => ({
    value: unit.value,
    label: formatFamiliarUnit(unit.value),
  }));
  const speechOptions = speechLevelsList().map((level) => ({
    value: level.value,
    label: formatSpeechLevel(level.value),
  }));
  const mobilityOptions = mobilityOptionsList().map((option) => ({
    value: option.value,
    label: formatMobilityOption(option.value),
  }));
  const emotionalStatusOptions = emotionalStatusList().map((option) => ({
    value: option.value,
    label: formatServiceHolderEmotionalStatus(option.value),
  }));
  const careAdaptationOptions = caretakerOptionsList().map((option) => ({
    value: option.value,
    label: formatServiceHolderAdopt(option.value),
  }));
  const sleepQualityOptions = sleepQualityOptionList().map((option) => ({
    value: option.value,
    label: formatServiceHolderSleepQuality(option.value),
  }));
  const toiletLevelOptions = toiletLevelsList().map((option) => ({
    value: option.value,
    label: formatServiceHolderToiletLevel(option.value),
  }));
  const salaryTypeOptions = [
    {
      value: "Diario",
      label: formatMessage({
        id: "ServiceValuationForm.SalaryType.Daily",
        defaultMessage: "Diario",
      }),
    },
    {
      value: "Mensual",
      label: formatMessage({
        id: "ServiceValuationForm.SalaryType.Monthly",
        defaultMessage: "Mensual",
      }),
    },
  ];
  const officialDegreeOptions = degreesListWithNotNeededOption().map(
    (option) => ({
      value: option.value,
      label: option.label,
    })
  );
  const serviceHolderUserStatusOptions = serviceHolderUserStatusList().map(
    (option) => ({
      value: option.value,
      label: formatServiceHolderUserStatus(option.value),
    })
  );
  const dependencyOptions = dependencyGradesList().map((option) => ({
    value: option.value,
    label: option.value,
  }));

  return {
    regionOptions,
    areaOptions,
    familiarUnitOptions,
    speechOptions,
    mobilityOptions,
    emotionalStatusOptions,
    careAdaptationOptions,
    sleepQualityOptions,
    toiletLevelOptions,
    salaryTypeOptions,
    officialDegreeOptions,
    serviceHolderUserStatusOptions,
    dependencyOptions,
  };
}
